define('modules/lists/modals/views/delete.contact.from.list.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    //'modules/bulkOperations/models/bulk.identities.request.model',
    'modules/base/modals/views/modal.view',
    "text!modules/lists/modals/templates/delete.contact.from.list.template.html"
], function(
    Prospector,
    $, _,Backbone,
    //BulkIdentitiesRequestModel,
    ModalView,
    Template
){
    var DeleteContactFromListView = ModalView.extend({
        template: _.template(Template),
        mainBtnLoaderRestingText: 'Delete',
        mainBtnLoaderWorkingText: 'Deleting...',
        mainBtnLoaderClass: 'reload_white_red_25',
        initialize: function(options) {
            this.debugName = 'move list view';
            var that = this;
            this.identityModel = options.model;
            this.listModel = options.listModel;
            ModalView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            //this.model = new BulkIdentitiesRequestModel();

        },
        onRender:function(){
            this.procResponse();
            ModalView.prototype.onRender.call(this);
        },
        procResponse:function(){
            this.$('.ripple').hide();
            this.$('.modal-body').show();
            this.$('.modal-text').html('Delete "' + this.identityModel.getName() +'" from "' + this.listModel.get('name') + '"?');
        },
        procMainBtn:function(e){
            this.model.set({
                "action": "Delete",
                "identities": [{
                    "id": this.identityModel.get('id'),
                    "source": this.identityModel.get('source')
                }],
                "parameters": {
                    "srcListId": this.listModel.get('id'),
                    "destListId": 0,
                    "formatId": 0,
                    "inferEmail": false,
                    "minInferredAccuracy": 0,
                    "inferredOptions": 0
                },
                "emails": [
                    {
                        "email": ""
                    }
                ]
            });
            this.model.once('sync', this.mainBtnResponse, this);
            this.model.save();
        },
        procMainBtnResponse:function(){
            if(!this.model.isValid()){
                this.errOut(this.model.errorMessage);
            } else {
                this.closeModal();
                this.parent.receiveChild({
                    mode: "deleteContact",
                    model: this.identityModel
                });
                Prospector.trigger('refreshLists');
            }
        }
    });
    return DeleteContactFromListView;
});
